import React, { Component } from 'react';
import { Pagination, Spin, Button, Modal } from 'antd';
import { CSVLink } from "react-csv";
import {formDataSchema} from '../../../schema/bill-tacking';
import Select2 from '../../../components/FormComponent/select2';
import Inputlayer from '../../../components/FormComponent/Input';
import DateRange from '../../../components/FormComponent/DateRange';
import { filter, formData, dissableFormData } from '../../../schema/apppointment';
import moment from 'moment';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';

const {homepage} = networkList;
let i = 0;
class Report_Finanical_Counselling extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            'loadding': false,
            'page_data_count': 1,
            'search_key': '',
            previlege_data: [],
            responseData: [],
            tableHead: [],
            page_length: 30,
            'total_items': 0,            
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),            
            'downloadtbody': [],
            downloadStatus: 0
        }
    }

    componentDidMount() {
        let tableHead = [{
            'key': 'ip',
            'text': 'IP Number'
        }, {
            'key': 'fc_id',
            'text': 'Counselling ID'
        }, {
            'key': 'umr',
            'text': 'UMR number'
        }, {
            'key': 'name',
            'text': 'Patient Name'
        }, {
            'key': 'service_name',
            'text': 'Service Name'
        },{
            'key': 'payment_type',
            'text': 'Payment Type'
        },{
            'key': 'care_management',
            'text': 'Care Management'
        },
         {
            'key': 'phno',
            'text': 'Phone Number'
        }, {
            'key': 'counselled_by',
            'text': 'Counselled By'
        }, {
            'key': 'date',
            'text': 'Counselled Date'
        }, {
            'key': 'procedure_tat',
            'text': 'Transaction TAT'
        }, {
            'key': 'total_estimate_amt',
            'text': 'Total Estimate Amount'
        },
        {
            'key': 'covid_status',
            'text': 'Covid Status'
        }
        
        // , {
        //     'key': 'admission_status',
        //     'text': 'Status'
        // }
    
    ];

        this.setState((state) => ({ 'tableHead': tableHead, search_key: '' }), () => {
            this.renderBody();
        })

    }

    renderBody() {
        i = 0;
        let { getCounsellingsList } = networkList;
        let { page_data_count, search_key } = this.state;
        this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0  }));
        let This = this;
        try {
            let userData = localStorage.getItem('user_data');
            if(userData !== undefined && userData !== null && userData !== ''){
                userData = JSON.parse(userData);
            }
            postService(getCounsellingsList, 'POST', { 
                'data': { "unit_id":userData ? userData['unitid'] ? userData['unitid'] :null :null, 
                        'page_no': page_data_count, 
                        'page_number': page_data_count, 
                        'page_data_count': page_data_count, 
                        "search_key": search_key,
                        "from": search_key ? '' : moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        "to":  search_key ? '' : moment(this.state.dateTo).format('YYYY-MM-DD'),
                        "export": 0, //1 for download excel
                        } 
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                    let newArray = [];
                    res['data'].map((row, rkey) => {
                        row['s_no'] = rkey;
                        if (row['data'] && Array.isArray(row['data']) && row['data'].length !== 0) {
                            if (row['data'].length === 1) {
                                row['data'][0]['haschild'] = false;
                                row['data'][0]['s_no'] = rkey;
                                row['data'][0]['date'] = row['date'];
                                newArray.push(row['data'][0]);
                            } else {
                                row['haschild'] = true;
                                newArray.push(row);
                                row['data'].map((subrow, skey) => {
                                    subrow['child'] = true;
                                    subrow['parrent_id'] = `collapse_${row['admissions_id']}`;
                                    newArray.push(subrow);
                                })
                            }
                        } else {
                            row['s_no'] = rkey;
                            row['haschild'] = false;
                            newArray.push(row);
                        }
                    })
console.clear();

                    console.log(newArray);

                    this.setState((state) => ({ 'responseData': newArray, 'previlege_data': res['previlege_data'], 'total_items': res['total_items'] }))
                    // enable downloadbtn after 2sec
                    setTimeout(function () {
                        This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                } else {
                    this.setState((state) => ({ 'responseData': [], 'previlege_data': [], 'total_items': 0 }))

                }
            } else {
                if (res === 401) {

                } else {
                    Modal.error({
                        title: 'Failure',
                        content: "Oops! something went wrong... Please try again.",
                    });
                }

            }
            })
            let dwntablehead=[{
                'key': 'ip',
                'label': 'IP Number'
            }, {
                'key': 'fc_id',
                'label': 'Counselling ID'
            }, {
                'key': 'umr',
                'label': 'UMR number'
            }, {
                'key': 'name',
                'label': 'Patient Name'
            }, {
                'key': 'service_name',
                'label': 'Service Name'
            }, {
                'key': 'phno',
                'label': 'Phone Number'
            }, {
                'key': 'counselled_by',
                'label': 'Counselled By'
            }, {
                'key': 'date',
                'label': 'Counselled Date'
            }
            
            // , {
            //     'key': 'admission_status',
            //     'text': 'Status'
            // }
        
        ]            

        } catch (error) {
            this.setState((state) => ({ loadding: false }));
        }
    }

    // navigateTo(id, ip, service) {
    //     let { previlege_data } = this.state;
    //     if (previlege_data.includes(service)) {
    //         if (id !== undefined && id !== null && id !== '') {
    //             this.props
    //                 .history
    //                 .push(`/counselling/view-finanical-counselling?rid=${id}`);
    //         } else {
    //             this.props
    //                 .history
    //                 .push(`/counselling/view-finanical-counselling?rid=${id}&ip=${ip}`);
    //         }
    //     }else{
    //         if (id !== undefined && id !== null && id !== '') {
    //             this.props
    //                 .history
    //                 .push(`/counselling/view-other-counselling?rid=${id}`);
    //         } else {
    //             this.props
    //                 .history
    //                 .push(`/counselling/view-other-counselling?rid=${id}&ip=${ip}`);
    //         }
    //     }

    // }

    navigateTo(payment_type_id, counselling_id, form_type) {
        window.open(`${homepage}/counselling/view-finanical-counselling?pid=${payment_type_id}&cid=${counselling_id}&fid=${form_type}`, '_blank', 'noopener,noreferrer');
        // this.props.history.push(`/counselling/view-finanical-counselling?pid=${payment_type_id}&cid=${counselling_id}&fid=${form_type}`);
        // this.props.history.push('/counselling/basic-details?cd=1&rid='+counselling_id);
    }



    pageChange(data) {
        this.setState((state) => ({ 'page_data_count': data }), () => {
            this.renderBody();
        })
    }

    searchClick() {
        i = 0;
        this.setState((state) => ({ 'page_data_count': 1 }), () => {
            this.renderBody();
        })
    }


    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({ 'search_key': value }), () => {

        });
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    indexIncrement() {
        i = i + 1;
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
            page_data_count: 1,
            search_key: '' 
        }), () => {
            this.inputRef.value = null;
            this.renderBody(true);
        })        
    }
    downloadFile() {
        i = 0;
        let { getCounsellingsList } = networkList;
        let { page_data_count, search_key } = this.state;
        this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0  }));
        let This = this;
        try {
            let userData = localStorage.getItem('user_data');
            if(userData !== undefined && userData !== null && userData !== ''){
                userData = JSON.parse(userData);
            }
            let dwntablehead=[{
                'key': 'ip',
                'label': 'IP Number'
            }, {
                'key': 'fc_id',
                'label': 'Counselling ID'
            }, {
                'key': 'umr',
                'label': 'UMR number'
            }, {
                'key': 'name',
                'label': 'Patient Name'
            }, {
                'key': 'service_name',
                'label': 'Service Name'
            }, 
            {
                'key': 'payment_type',
                'label': 'Payment Type'
            },{
                'key': 'care_management',
                'label': 'Care Management'
            },{
                'key': 'phno',
                'label': 'Phone Number'
            }, {
                'key': 'counselled_by',
                'label': 'Counselled By'
            }, {
                'key': 'date',
                'label': 'Counselled Date'
            }, {
                'key': 'procedure_tat',
                'label': 'Transaction TAT'
            }, {
                'key': 'total_estimate_amt',
                'label': 'Total Estimate Amount'
            },{
                'key': 'covid_status',
                'text': 'Covid Status'
            }
            
            // , {
            //     'key': 'admission_status',
            //     'text': 'Status'
            // }
        
        ]
                This.setState((state) => ({ downloadStatus: 0, downloadthead: dwntablehead, filename: 'Financial-Counselling.csv', download_btn: true, loadding: true }), () => {
                    postService(getCounsellingsList, 'POST', { 
                        'data': { "unit_id":userData ? userData['unitid'] ? userData['unitid'] :null :null, 
                                'page_no': 0, 
                                'page_number': 0, 
                                'page_data_count': 0, 
                                "search_key": search_key,
                                "from": search_key ? '' :moment(This.state.dateFrom).format('YYYY-MM-DD'),
                                "to":  search_key ? '' : moment(This.state.dateTo).format('YYYY-MM-DD'),
                                "export": 1, //1 for download excel
                                } 
                    }).then(res => {
                        console.log('tat report:', res.data);
                        if (res.status) {
                            if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                                let newArray = [];
                                res['data'].map((row, rkey) => {
                                    row['s_no'] = rkey;
                                    if (row['data'] && Array.isArray(row['data']) && row['data'].length !== 0) {
                                        if (row['data'].length === 1) {
                                            row['data'][0]['haschild'] = false;
                                            row['data'][0]['s_no'] = rkey;
                                            row['data'][0]['date'] = row['date'];
                                            newArray.push(row['data'][0]);
                                        } else {
                                            row['haschild'] = true;
                                            newArray.push(row);
                                            row['data'].map((subrow, skey) => {
                                                subrow['child'] = true;
                                                subrow['parrent_id'] = `collapse_${row['admissions_id']}`;
                                                newArray.push(subrow);
                                            })
                                        }
                                    } else {
                                        row['s_no'] = rkey;
                                        row['haschild'] = false;
                                        newArray.push(row);
                                    }
                                })
            console.clear();
            
                                console.log(newArray);
                                let downloadtablebody =[]
                                if(newArray && newArray.length !== 0)
                                    {
                                        newArray.map((data, key) => {
                                            if (data['haschild'] === false) {
                                                downloadtablebody.push(data);                                            
                                            }
                                            if ((data['haschild'])) {
                                                // downloadtablebody.push(data);
                                                data['data'].map((subrow, skey) => {
                                                    downloadtablebody.push(subrow);                                                                                                       
                                                })
                                            }                                        
                                    })
                                if(downloadtablebody && downloadtablebody.length !== 0) {
                                    downloadtablebody.map((data, key) => {                                        
                                        dwntablehead.map((dataKey) => {
                                            if (dataKey.key === 'date') {
                                                downloadtablebody[key]["date"] = downloadtablebody[key]["date"] ? moment(downloadtablebody[key]["date"]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                            } else {
                                            // downloadtablebody.push(data);
                                            downloadtablebody[key][dataKey.key] = (downloadtablebody[key][dataKey.key] || downloadtablebody[key][dataKey.key] == 0) ? downloadtablebody[key][dataKey.key] : 'NA'
                                            }
                                        })
                                    })
                                }
                                    // console.log('downloadtablebody:',downloadtablebody)
                                }
                                This.setState((state) => ({ downloadStatus: 1, downloadtbody: downloadtablebody ? downloadtablebody : [], loadding: false }));
                                this.csvLink.current.link.click();
                            }
                           
                        } else {
                            if (res === 401) {

                            } else {
                                Modal.error({
                                    title: 'Failure',
                                    content: "Oops! something went wrong... Please try again.",
                                });
                            }
                        }
                    });
                });

        } catch (error) {
            this.setState((state) => ({ loadding: false }));
        }
    }
    render() {
        let { responseData, tableHead, previlege_data, total_items, page_data_count, page_length, download_btn, downloadStatus, filename, downloadtbody, downloadthead } = this.state;

        return (
            <div>
                 {
                    download_btn
                        ?
                        downloadStatus && responseData != ''
                            ?
                            <div className="row mb-2 ml-5 mr-5 download sticky-top d-flex flex-row-reverse">
                                <button className="btn btn-success text-capitalize float-left" onClick={()=>{this.downloadFile()}}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span></button>
                                <CSVLink data={downloadtbody} headers={downloadthead} filename={filename} className="hidden" ref={this.csvLink} />
                            </div>
                            :
                            <div className="row mb-2 ml-5 mr-5 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize float-left" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                            </div>
                        :
                        <div className="mt-5" />
                }
                <div className="card mx-5 mb-5 card-table">

                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className="float-left pt-1">
                                Financial Counselling
                            </div>
                            <div className=" row">
                                {formDataSchema.feilds
                                    .map((feild, key) => {

                                        if (feild.element === 'input' && feild.visible) {
                                            return (                                                
                                            <div className="col-6 mx-auto">
                                                <div class="input-group">
                                                    <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" onBlur={this.searchChange.bind(this)} ref={(inputRef =>(this.inputRef = inputRef))} />
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                    </div>
                                                </div>
                                            </div>
                                            )
                                        }
                                        if (feild.element === 'daterange') {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} ${feild.name}`}
                                                    key={key}>
                                                    {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                                                    
                                                    <DateRange
                                                        Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] });  }}
                                                    />
                                                    <div class="input-group-append">                                                                           
                                                        <button class="btn btn-primary btn-sm ml-1" onClick={()=>{this.dateRange()}}>Go</button>
                                                    </div>
                                                    {/* ,()=>this.renderBody() */}
                                                </div>
                                            )
                                        }
                                        // if (feild.element === 'select2' && feild.visible) {
                                        //     return (
                                        //         <React.Fragment key={key}>
                                        //             {(feild.name === 'patient_list' && feild.disable === false) &&
                                        //                 <div className="col-6">
                                        //                     <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                        //                 </div>}
                                        //             <div
                                        //                 className={`${feild.className
                                        //                     ? feild.className
                                        //                     : 'col '} ${feild.name}`}
                                        //                 key={key}>
                                        //                 <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                        //                 <Select2
                                        //                     Queuedata={formData}
                                        //                     selectdata={feild}
                                        //                     {...this.props}
                                        //                     {...this.state}
                                        //                 /> {feild
                                        //                     .errors
                                        //                     .map((error, eKey) => {
                                        //                         return (
                                        //                             <small key={eKey} className="form-text text-danger">{error.message}</small>
                                        //                         );
                                        //                     })}
                                        //             </div>
                                        //         </React.Fragment>
                                        //     )
                                        // }
                                    })}
                            </div>
                        </div>
                    </div>

                    <div className="financial-table table-responsive sticky-header" id="table">
                        <table className="table table-hover table-bordered mb-0 bg-white" style={{width: '120%'}}>
                            <thead>
                                <tr>
                                    <td>S.no</td>
                                    {tableHead.map((head, key) => {
                                        return (<td key={key}>{head.text}</td>);
                                    })}
                                    {/* <td>S.no</td>
                                    <td>FC Number</td>
                                    <td>IP Number</td>
                                    <td>UMR Number</td>
                                    <td>Patient Name</td>
                                    <td>Phone Number</td>
                                    <td>Date</td>
                                    <td>Status</td> */}
                                </tr>
                            </thead>
                            <tbody>

                                {(responseData && responseData.length !== 0) && <React.Fragment>
                                    {responseData.map((data, bKey) => {
                                          

                                          console.log(data);
                                        if (data['haschild'] === false) {
                                            this.indexIncrement();
                                            return (<tr key={bKey} style={{ 'cursor': 'pointer' }} onClick={this.navigateTo.bind(this, data['payment_type_id'], data['id'], data['form_type'])}>
                                                <td>{( page_data_count == 1 ) ? data['s_no']+1 : data['s_no']+1+30*(page_data_count > 2 ? page_data_count-1 : 1) }</td>                                                

                                                {tableHead.map((head, key) => {
                                                    if (head['key'] !== 'date' && head['key'] === 'ip' && data['service_id'] && previlege_data.includes(data['service_id'])) {
                                                        return (<td key={key} className='pointer' >{data[head['key']] ? data[head['key']] : 'NA'}</td>);
                                                    } else if(head['key'] === 'date') {
                                                        return (<td key={key}>{data[head['key']] ? moment(data[head['key']]).format('DD-MM-YYYY HH:mm') : 'NA'}</td>);
                                                    } else {
                                                        return (<td key={key}>{data[head['key']] ? data[head['key']] : 'NA'}</td>);
                                                    }
                                                })}
                                            </tr>)
                                        }

                                        if (data['haschild'] === true || data['child']) {
                                            if (data['haschild']) {
                                                this.indexIncrement();
                                            }
                                            return (<React.Fragment>
                                                {(data['haschild']) &&
                                                    <tr style={{ 'cursor': 'pointer' }} className="accordion-toggle collapsed" id={`accordion_${data['admissions_id']}`} data-toggle="collapse" data-parent={`#accordion_${data['admissions_id']}`} href={`#collapse_${data['admissions_id']}`}>
                                                        <td class="expand-button" >{( page_data_count == 1 ) ? data['s_no']+1 : data['s_no']+1+30*(page_data_count > 2 ? page_data_count-1 : 1) }</td>                                                        
                                                        {tableHead.map((head, key) => {
                                                            if (head['key'] !== 'date' && head['key'] === 'ip' && data['service_id'] && previlege_data.includes(data['service_id'])) {
                                                                return (<td key={key} className='pointer' >{data[head['key']] ? data[head['key']] : 'NA'}</td>);
                                                            } else if(head['key'] === 'date') {
                                                                return (<td key={key}>{data[head['key']] ? moment(data[head['key']]).format('DD-MM-YYYY HH:mm') : 'NA'}</td>);
                                                            } else {
                                                                return (<td key={key}>{data[head['key']] ? data[head['key']] : 'NA'}</td>);
                                                            }
                                                        })}
                                                    </tr>}
                                                {(data['child']) &&
                                                    <tr className="hide-table-padding collapse in" style={{ 'cursor': 'pointer' }} id={`${data['parrent_id']}`} onClick={this.navigateTo.bind(this, data['payment_type_id'], data['id'], data['form_type'])}>
                                                        <td></td>                                                        
                                                        {tableHead.map((head, key) => {
                                                            if (head['key'] !== 'date' && head['key'] === 'ip' && data['service_id'] && previlege_data.includes(data['service_id'])) {
                                                                return (<td key={key} className='pointer' >{data[head['key']] ? data[head['key']] : 'NA'}</td>);
                                                            } else if(head['key'] === 'date') {
                                                                return (<td key={key}>{data[head['key']] ? moment(data[head['key']]).format('DD-MM-YYYY HH:mm') : 'NA'}</td>);
                                                            } else {
                                                                return (<td key={key}>{data[head['key']] ? data[head['key']] : 'NA'}</td>);
                                                            }
                                                        })}
                                                    </tr>}

                                            </React.Fragment>)
                                        }
                                    })}
                                </React.Fragment>}

                                {(responseData && responseData.length === 0) && <React.Fragment>
                                   
                                     <tr>
                                         <td colSpan={tableHead.length+1} className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                         </td>
                                        </tr> 
                                        
                                </React.Fragment>}


                            </tbody>
                        </table>
                    </div>
                </div>
                {(this.state.loadding) &&
                    <div className="loadding"> <Spin tip="Loading..." size={'large'}></Spin></div>}
                <div className="col-6 offset-3 text-center mb-5">
                    <Pagination current={page_data_count} total={total_items} itemRender={this.itemRender.bind(this)} pageSize={page_length} showSizeChanger={false} onChange={this.pageChange.bind(this)} />
                </div>
            </div>
        )
    }
}

export default Report_Finanical_Counselling;